import React from "react";
import { Box } from "grommet";
import { ViewUsers } from "../../components/ManagerPortal/ViewUsers";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader"; // If you have a global header
import { StickyFooter } from "../../components/Footers/GlobalFooter"; // If you have a global footer
import ManageUsers from "../../components/ManagerPortal/ManageUsers";
import { useNavigate } from "react-router-dom";

export const GroupUsersPage = () => {
  const { state } = useNavigate();
  const groupName = state?.groupName || "";

  
  return (
    <Box fill="vertical" justify="between">
      {/* Global Header */}
      <HeaderNavigation />

      {/* Main Manager Dashboard Component */}
      <Box flex="grow" pad="medium">
        {/* <ManageUsers manager_id={manager_id} /> */}
        <ViewUsers groupName={groupName} />
      </Box>

      {/* Global Footer */}
      <StickyFooter />
    </Box>
  );
};
